export default "__VITE_ASSET__BnBTZGJz__";